import { useEffect, useRef, useState } from 'react';

export const useHoverWithDelayedExit = (delay: number = 3000) => {
	const [isHovered, setIsHovered] = useState(false);
	const timerRef = useRef<number | null>(null);

	const handleMouseEnter = () => {
		if (timerRef.current) {
			window.clearTimeout(timerRef.current);
			timerRef.current = null;
		}
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		if (timerRef.current) {
			window.clearTimeout(timerRef.current);
		}
		timerRef.current = window.setTimeout(() => setIsHovered(false), delay);
	};

	useEffect(() => {
		return () => {
			if (timerRef.current) {
				window.clearTimeout(timerRef.current);
			}
		};
	}, []);

	return { isHovered, handleMouseEnter, handleMouseLeave };
};
